import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: 'bx bxl-github', url: 'https://github.com/moteaz', label: 'GitHub' },
    { icon: 'bx bxl-linkedin', url: 'https://www.linkedin.com/in/motezhalleb/', label: 'LinkedIn' },
    { icon: 'bx bxl-instagram', url: 'https://www.instagram.com/motez_halleb/', label: 'Instagram' }
  ];

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__content">
          <div className="footer__brand">
            <h2 className="footer__logo">Moetaz Halleb</h2>
            <p className="footer__tagline">Full Stack Developer</p>
            <p className="footer__description">Building modern web applications with passion and precision</p>
          </div>

          <div className="footer__social-section">
            <h3 className="footer__section-title">Connect With Me</h3>
            <div className="footer__social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="footer__social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
            <div className="footer__contact-info">
              <a href="mailto:mootazhalleb@gmail.com" className="footer__email">
                <i className="bx bx-envelope"></i>
                mootazhalleb@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__divider"></div>
          <div className="footer__copyright">
            <p>&copy; {currentYear} Moetaz Halleb. All rights reserved.</p>
            <p className="footer__made-with">
              Made with <i className="bx bxs-heart"></i> using React
            </p>
          </div>
        </div>


      </div>
    </footer>
  )
}

export default Footer
